import { combineReducers, configureStore } from "@reduxjs/toolkit";
// import { createStore, applyMiddleware, combineReducers } from "redux";
import logger from "redux-logger";
import thunkMiddleware from "redux-thunk";
import { persistStore, persistReducer } from "reduxjs-toolkit-persist";
import storage from "reduxjs-toolkit-persist/lib/storage";

import login from "./features/loginSlice";
import apimessage from "../redux/features/globalApiMessageSlice";
import landing from "../redux/features/landingSlice";
import search from "SearchResults/SearchSlice";
import reports from "USERPROFILE/ReportsSlice";
import itemDetail from "ItemDetails/itemDetailSlice";
import templateDetail from "ItemDetails/templateDetailSlice";
import accountManage from "USERPROFILE/userProfileSlice";
import salesTeam from "USERPROFILE/SalesTeamSliceIndex";
import userSearch from "USERPROFILE/userSearch";
import user from "USERPROFILE/user";
import product from "USERPROFILE/product";
import email from "USERPROFILE/emailSlice";
import { messagesApi } from "USERPROFILE/messagesApi";
import messages from "USERPROFILE/messagesSlice";
import cart from "Cart/cartSlice";
import orderType from "Cart/orderSlice";
import checkout from "CHECKOUT/CheckoutSlice";
import Addresses from "CHECKOUT/addressSlice";
import HcpAddresses from "CHECKOUT/HcpSlice";
import Hcp360Addresses from "CHECKOUT/Hcp360Slice";
import ShippingType from "CHECKOUT/ShippingTypeSlice";
import ShipToDistribution from "CHECKOUT/shipToDistributionSlice";
import collection from "COLLECTION/collectionSlice";
import orderSearch from "CHECKOUT/orderSearchSlice";
import loading from "../redux/features/loading";
import notification from "../redux/features/notificationSlice";
import support from "USERPROFILE/supportSlice";
import announcement from "USERPROFILE/announcementSlice";
import addressbook from "ADDRESSBOOK/AddressBookSlice";
import { userAllocationApi } from "USERPROFILE/userAllocationApi";
import { personalizeMessageSlice } from "CHECKOUT/personalizeMessageSlice";
const persistConfig = {
  key: "root",
  storage,
};
// const persistLoginReducerConfig = {
//   key: "login",
//   debug: true,
//   storage,
// };
// const persistSearchConfig = {
//   key: "itemDetail",
//   debug: true,
//   storage,
// };
// const persistItemConfig = {
//   key: "itemDetail",
//   debug: true,
//   storage,
// };
// const persistCheckoutConfig = {
//   key: "checkout",
//   debug: true,
//   storage,
// };
// const persistCartConfig = {
//   key: "cart",
//   debug: true,
//   storage,
// };
// const persistLandingConfig = {
//   key: "landing",
//   debug: true,
//   storage,
// };
// const middlewares = [thunkMiddleware, logger];
const staticReducers = {
  login,
  loading,
  search,
  cart,
  orderType,
  itemDetail,
  checkout,
  Addresses,
  HcpAddresses,
  Hcp360Addresses,
  ShippingType,
  ShipToDistribution,
  landing,
  apimessage,
  collection,
  accountManage,
  templateDetail,
  salesTeam,
  orderSearch,
  personalizeMessageSlice,
  reports,
  userSearch,
  email,
  user,
  product,
  notification,
  support,
  announcement,
  addressbook,
  messages,
  [userAllocationApi.reducerPath]: userAllocationApi.reducer,
  [messagesApi.reducerPath]: messagesApi.reducer,
  [personalizeMessageSlice.reducerPath]: personalizeMessageSlice.reducer,
};
export const configureStoreFn = (initialState = {}) => {
  const reducer = combineReducers({ ...staticReducers });
  const reducerProxy = (state, action) => {
    if (action.type === "login/resetLoginData") {
      return reducer(undefined, action);
    }
    console.log(state, "this is state");
    return reducer(state, action);
  };
  const _persistedReducer = persistReducer(persistConfig, reducerProxy);
  // const store = createStore(
  //   reducer:_persistedReducer,
  //   initialState,
  //   applyMiddleware(...middlewares)
  // );
  // const persistor = persistStore(store, null, () => {
  //   console.log("restoredState", store.getState());
  // });

  const store = configureStore({
    reducer: _persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false })
        .concat(userAllocationApi.middleware)
        .concat(messagesApi.middleware)
        .concat(
          personalizeMessageSlice.middleware
        )
        .concat(logger),
  });
  const persister = persistStore(store);
  return { store, persister };
};
